import React from 'react';
import Button from '../Button';
import { st, classes } from './MessageBoxFunctionalLayout.st.css';
import { dataHooks } from './constants';

const buttonSkinByTheme = {
  blue: 'standard',
  purple: 'premium',
  red: 'destructive',
};

const buttonSizeByHeight = {
  'x-small': 'tiny',
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
  'x-large': 'large',
};

const Footer = ({
  bottomChildren,
  children,
  theme = 'blue',
  cancelText,
  cancelPrefixIcon,
  cancelSuffixIcon,
  onCancel,
  onOk,
  confirmText,
  confirmPrefixIcon,
  confirmSuffixIcon,
  buttonsHeight = 'small',
  enableOk = true,
  enableCancel = true,
  sideActions,
  newColorsBranding,
}) => (
  <>
    <div
      className={st(classes.footer, { newColorsBranding })}
      data-hook={dataHooks.footer}
    >
      {sideActions}
      {children}
      <div
        className={st(classes.footerbuttons, {
          withSideActions: sideActions && (cancelText || confirmText),
        })}
      >
        {cancelText && (
          <Button
            prefixIcon={cancelPrefixIcon}
            suffixIcon={cancelSuffixIcon}
            disabled={!enableCancel}
            size={buttonSizeByHeight[buttonsHeight]}
            priority="secondary"
            skin={buttonSkinByTheme[theme]}
            onClick={onCancel}
            dataHook={dataHooks.footerCancelButton}
            children={cancelText}
          />
        )}
        {confirmText && (
          <Button
            prefixIcon={confirmPrefixIcon}
            suffixIcon={confirmSuffixIcon}
            disabled={!enableOk}
            size={buttonSizeByHeight[buttonsHeight]}
            priority="primary"
            skin={buttonSkinByTheme[theme]}
            onClick={onOk}
            dataHook={dataHooks.footerConfirmButton}
            children={confirmText}
          />
        )}
      </div>
    </div>
    {bottomChildren && (
      <div
        data-hook={dataHooks.footerBelowChildren}
        className={st(classes.bottomChildren, { newColorsBranding })}
        children={bottomChildren}
      />
    )}
  </>
);

export default Footer;
